export default {
    figures: {
        canvas: {
            loading: '圖片刷新中，請耐心等候...',
            aiUpdating: 'AI 正在編輯附圖...',
            emptyTitle: '開始描述你想要的附圖',
            emptyDesc: '在右側對話框中輸入詳細描述',
            annotationInfo: {
                button: '標號',
                loading: '載入中…',
                empty: '此圖暫無標引資訊',
                numeralHeader: '標號',
                componentHeader: '部件名',
                editHint: '點擊部件名可編輯',
                addRow: '新增標號',
                addNumeralPlaceholder: '標號（數字）',
                addComponentPlaceholder: '部件名',
                addComponentReuseHint: '已存在，將使用現有部件名',
                addCancel: '取消',
                addConfirm: '新增',
                deleteConfirm: '從本圖移除標號 {numeral}？',
                deleteCancel: '取消',
                deleteOk: '移除',
                errorNumeralFormat: '標號僅允許純數字或數字+字母',
                errorNumeralRequired: '請填寫標號',
                errorComponentRequired: '請填寫部件名',
            },
        },
        annotationConfirm: {
            reconfirmBanner: '此專案已有確認的標引對照表，目前為重新調整模式',
            defaultTitle: '請確認標引對照表',
            colNumeral: '標號',
            colFeature: '特徵（部件名）',
            colFigures: '適用附圖',
            colEmbodiment: '實施例',
            colAnchor: '標引重點',
            figuresEmpty: '（未選擇）',
            embodimentPlaceholder: '如：第一實施例',
            addRow: '＋ 新增標引項',
            confirm: '確認並開始標引',
            confirmed: '已確認',
            warnNumeralDup: '標號 "{numeral}" 重複',
            warnComponentDup: '特徵名 "{name}" 重複，請確認是否正確',
            warnNewRowNoFigure: '新增行必須選擇適用附圖',
            warnNoFigure: '未選擇適用附圖，將適用所有圖',
            submitHint: '已確認標引對照表，共 {count} 項',
            submitHintNext: '，請開始標引第一張：{figureNo}',
        },
        fineTune: {
            button: '微調',
            preparing: '準備中',
            title: '局部微調',
            close: '關閉',
            placeholder: '描述希望模型如何修改選中的區域...',
            selectionCount: '已選擇 {count} 個網格',
            clear: '清空',
            addOperation: '新增要求',
            submitAll: '提交全部',
            operationTitle: '要求 {index}',
            remove: '刪除要求',
        },
        panel: {
            title: '附圖編輯器',
            reset: '重置',
            submit: '儲存',
            newFigureGenerated: '新附圖已生成並加入縮略圖列表，目前圖有未儲存修改，暫未自動切換。',
            unsavedChanges: '目前附圖有未儲存修改。切換後這些修改不會自動儲存，確認繼續嗎？',
            unsavedChangesTitle: '未儲存修改',
            continueSwitch: '繼續切換',
            cancel: '取消',
            resetConfirmTitle: '重置確認',
            resetConfirm: '確認丟棄目前修改，恢復到上次儲存的狀態？',
            confirmReset: '確認重置',
            uploadFailed: '上傳失敗：{fileName}',
            renameFailed: '重命名失敗，請稍後重試',
        },
        uploadDialog: {
            title: '上傳附圖',
            aiGenerate: 'AI生成',
            aiGenerateDesc: '通過AI生成專業附圖',
            normalUpload: '普通上傳',
            normalUploadDesc: '從本地上傳圖片檔案',
            fromFile: '來自檔案',
            fromFileDesc: '從已上傳的檔案中選擇',
            editFigure: '編輯附圖',
        },
        attachmentPicker: {
            title: '選擇附件圖片',
            subtitle: '可選擇專案附件中的原圖，或文件/PDF 中提取出的圖片',
            addToCanvasSubtitle: '點擊選擇圖片，添加到畫布上',
            empty: '目前專案附件中暫無可用圖片',
            loadFailed: '載入附件圖片失敗，請稍後再試',
            importFailed: '匯入附件圖片失敗，請稍後再試',
            sourcePrefix: '來源：',
            tableImage: '表格圖片',
            selectedCount: '已選擇 {count} 張圖片',
            cancel: '取消',
            confirm: '確定',
        },
        collapsePanel: '收起',
        exportPdf: '匯出 PDF',
        chat: {
            title: 'Hiro',
            historyTitle: '歷史對話',
            newChat: '新對話',
            languageLabel: '模型輸出語言',
            welcome: '你好！我可以幫你生成各種技術附圖。描述你想要的附圖內容，我會根據你的需求生成專業的圖紙。',
            suggestedTasksWithFigures: [
                { title: '一致性檢查', desc: '掃描所有 Fig 標注與說明書的對應關係', prompt: '請檢查所有附圖標注與說明書的一致性' },
                { title: '生成附圖說明', desc: '基於當前所有 Fig 標注一鍵生成文字', prompt: '請基於當前所有附圖標注生成附圖說明' },
                { title: '編號管理', desc: '批量重新命名/調整順序/同步引用', prompt: '請幫我批量管理附圖編號，包括重新命名、調整順序和同步引用' },
            ],
            suggestedTasksNoFigures: [
                { title: '根據交底書/權利要求/說明書生成附圖', desc: '從現有材料自動提取技術方案生成 Fig', prompt: '請根據交底書/權利要求/說明書生成附圖' },
                { title: '優化並補齊現有附圖', desc: '上傳已有附圖，自動優化並補充缺失 Fig', prompt: '請優化並補齊現有附圖' },
                { title: '繪製所有附圖', desc: '從零開始描述需求，逐一生成全套附圖', prompt: '請從零開始幫我繪製所有附圖' },
            ],
            inputPlaceholder: '描述你想要的附圖內容，輸入 {\'@\'} 引用資源...',
            mentionResource: '引用資源',
            awaitingGeneration: '附圖正在生成中，請稍候...',
            fineTunePrompt: {
                targetFigure: '目標附圖：{figureName}',
                targetFileId: '目標附圖 file_id：{fileId}',
                gridRule: '網格規則：目標附圖會被劃分為 10x10 網格，行 A-J 從上到下，列 1-10 從左到右；A1 是左上角，J10 是右下角。',
                editTarget: '調用 draw_patent_figures 時，請將該 file_id 放入 file_ids_to_edit，用它作為本次編輯目標。',
                instruction: '請僅針對目標附圖「{figureName}」中以下 10x10 網格區域進行局部微調，不要修改其他附圖。',
                selectedCells: '{index}. 選中區域：{cells}',
                modifyRequirement: '   修改要求：{instruction}',
            },
            history: {
                title: '歷史對話',
                empty: '暫無歷史對話',
                search: '搜尋對話...',
                rename: '重新命名',
                delete: '刪除',
                defaultTitle: '新對話',
                today: '今天',
                yesterday: '昨天',
                lastWeek: '最近一週',
                lastMonth: '最近一個月',
                older: '更早',
            },
        },
    },
};
